/*
Copyright 2015, 2016 OpenMarket Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

'use strict';

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _SettingsStore = require('../../../settings/SettingsStore');

var _SettingsStore2 = _interopRequireDefault(_SettingsStore);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _languageHandler = require('../../../languageHandler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = require('react');


var sdk = require('../../../index');
var dis = require('../../../dispatcher');


module.exports = React.createClass({
    displayName: 'MemberTile',

    propTypes: {
        member: _propTypes2.default.any.isRequired, // RoomMember
        showPresence: _propTypes2.default.bool
    },

    getDefaultProps: function getDefaultProps() {
        return {
            showPresence: true
        };
    },

    getInitialState: function getInitialState() {
        return {
            statusMessage: this.getStatusMessage()
        };
    },

    componentDidMount: function componentDidMount() {
        if (!_SettingsStore2.default.isFeatureEnabled("feature_custom_status")) {
            return;
        }
        var user = this.props.member.user;

        if (!user) {
            return;
        }
        user.on("User._unstable_statusMessage", this._onStatusMessageCommitted);
    },
    componentWillUmount: function componentWillUmount() {
        var user = this.props.member.user;

        if (!user) {
            return;
        }
        user.removeListener("User._unstable_statusMessage", this._onStatusMessageCommitted);
    },
    getStatusMessage: function getStatusMessage() {
        var user = this.props.member.user;

        if (!user) {
            return "";
        }
        return user._unstable_statusMessage;
    },
    _onStatusMessageCommitted: function _onStatusMessageCommitted() {
        // The `User` object has observed a status message change.
        this.setState({
            statusMessage: this.getStatusMessage()
        });
    },


    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
        if (this.member_last_modified_time === undefined || this.member_last_modified_time < nextProps.member.getLastModifiedTime()) {
            return true;
        }
        if (nextProps.member.user && (this.user_last_modified_time === undefined || this.user_last_modified_time < nextProps.member.user.getLastModifiedTime())) {
            return true;
        }
        return false;
    },

    onClick: function onClick(e) {
        dis.dispatch({
            action: 'view_user',
            member: this.props.member
        });
    },

    _getDisplayName: function _getDisplayName() {
        return this.props.member.name;
    },

    getPowerLabel: function getPowerLabel() {
        return (0, _languageHandler._t)("%(userName)s (power %(powerLevelNumber)s)", {
            userName: this.props.member.userId,
            powerLevelNumber: this.props.member.powerLevel
        });
    },

    render: function render() {
        var MemberAvatar = sdk.getComponent('avatars.MemberAvatar');
        var EntityTile = sdk.getComponent('rooms.EntityTile');

        var member = this.props.member;
        var name = this._getDisplayName();
        var presenceState = member.user ? member.user.presence : null;

        var statusMessage = null;
        if (member.user && _SettingsStore2.default.isFeatureEnabled("feature_custom_status")) {
            statusMessage = this.state.statusMessage;
        }

        var av = React.createElement(MemberAvatar, { member: member, width: 36, height: 36 });

        if (member.user) {
            this.user_last_modified_time = member.user.getLastModifiedTime();
        }
        this.member_last_modified_time = member.getLastModifiedTime();

        var powerStatusMap = new _map2.default([[100, EntityTile.POWER_STATUS_ADMIN], [50, EntityTile.POWER_STATUS_MODERATOR]]);

        // Find the nearest power level with a badge
        var powerLevel = this.props.member.powerLevel;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(powerStatusMap), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _step$value = (0, _slicedToArray3.default)(_step.value, 1),
                    pl = _step$value[0];

                if (this.props.member.powerLevel >= pl) {
                    powerLevel = pl;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        var powerStatus = powerStatusMap.get(powerLevel);

        return React.createElement(EntityTile, (0, _extends3.default)({}, this.props, { presenceState: presenceState,
            presenceLastActiveAgo: member.user ? member.user.lastActiveAgo : 0,
            presenceLastTs: member.user ? member.user.lastPresenceTs : 0,
            presenceCurrentlyActive: member.user ? member.user.currentlyActive : false,
            avatarJsx: av, title: this.getPowerLabel(), onClick: this.onClick,
            name: name, powerStatus: powerStatus, showPresence: this.props.showPresence,
            subtextLabel: statusMessage
        }));
    }
});
//# sourceMappingURL=MemberTile.js.map